import { CalendarIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CalendarClock = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarIcon {...rest} size={Sizes[size]} height={Sizes[size]} color={fill} />;
};

CalendarClock.displayName = 'CalendarClock';
